<kendo-dialog
   *ngIf="isConfirmationInProgress$ | async"
   class="confirm-dialog"
   (close)="cancel()"
   [minWidth]="450"
   [width]="width"
>
   <kendo-dialog-titlebar>
      <div class="title-bar">
         <div class="title-text sam-center sam-form-flex-row">
            <fa-icon [icon]="titleBarIcon" [fixedWidth]="true" class="window-icon sam-margin-right"></fa-icon>
            <samweb-text-with-overflow-tooltip
               [value]="
                  'brick.brick_definitions.directory_browser.edit_contact_details.confirmation_dialog.title' | translate
               "
               class="sam-margin-right sam-hide-overflow"
            ></samweb-text-with-overflow-tooltip>
         </div>
      </div>
   </kendo-dialog-titlebar>
   <div style="padding-bottom: 0.5em">
      {{ 'brick.brick_definitions.directory_browser.edit_contact_details.confirmation_dialog.message' | translate }}
   </div>
   <div *ngFor="let column of entriesForComparison$ | async; let i = index">
      <div *ngIf="(column | directoryColumnStructureData | async) === null" class="sam-form-flex-row">
         <div #header class="confirm-label sam-form-flex-row">
            <fa-icon [icon]="column.columnTyp.columnIcon" class="sam-margin-left" [fixedWidth]="true"></fa-icon>
            <div class="sam-margin-left">
               {{ column | directoryColumnTitle | async }}
            </div>
         </div>
         <div
            #oldValue
            class="sam-opacity-light confirm-value-to-overwrite sam-italic sam-margin-left sam-form-flex-row"
         >
            <div
               *ngIf="(column | directoryColumnValue: (directoryEditInfo$ | async).updatedEntry | async).length !== 0"
            >
               {{ column | directoryColumnValue: (directoryEditInfo$ | async).updatedEntry | async }}
            </div>
            <div
               *ngIf="(column | directoryColumnValue: (directoryEditInfo$ | async).updatedEntry | async).length === 0"
               class="sam-italic"
            >
               {{ '(none)' }}
            </div>
         </div>

         <div #separatorIcon class="sam-center sam-opacity-medium sam-margin-left sam-opacity-medium">➡</div>
         <div #newValue class="confirm-value sam-margin-left sam-form-flex-row">
            <div *ngIf="(column | directoryColumnValue: (directoryEditInfo$ | async).editedEntry | async).length !== 0">
               {{ column | directoryColumnValue: (directoryEditInfo$ | async).editedEntry | async }}
            </div>
            <div
               *ngIf="(column | directoryColumnValue: (directoryEditInfo$ | async).editedEntry | async).length === 0"
               class="sam-italic"
            >
               {{ '(none)' }}
            </div>
         </div>
      </div>
      <!-- Orgfields  -->
      <div *ngIf="(column | directoryColumnStructureData | async) !== null" class="sam-form-flex-row">
         <fa-icon
            [icon]="column.columnTyp.columnIcon"
            class="sam-margin-left sam-margin-right"
            [fixedWidth]="true"
         ></fa-icon>
         <div class="sam-margin-right confirm-label">
            {{ column | directoryColumnOrganisationUnit }}
         </div>
         <div
            *samwebVar="
               column
                  | directoryColumnStructureValue
                     : (column | directoryColumnValue: (directoryEditInfo$ | async).updatedEntry | async)
                  | async;
               let orgUnit
            "
            class="sam-center sam-form-flex-row sam-opacity-light confirm-value-to-overwrite"
         >
            <div *ngIf="orgUnit?.orgnum !== null">{{ orgUnit?.orgnum }}</div>
            <div *ngIf="orgUnit?.orgnum !== null && orgUnit?.id > 0" class="sam-margin-left sam-margin-right">·</div>
            <div>{{ orgUnit?.orgnam }}</div>
         </div>
         <div class="sam-center sam-opacity-medium sam-margin-left sam-margin-right sam-opacity-medium">➡</div>
         <div
            *samwebVar="
               column
                  | directoryColumnStructureValue
                     : (column | directoryColumnValue: (directoryEditInfo$ | async).editedEntry | async)
                  | async;
               let orgUnit
            "
            class="sam-center sam-form-flex-row confirm-value"
         >
            <div *ngIf="orgUnit?.orgnum !== null">{{ orgUnit?.orgnum }}</div>
            <div *ngIf="orgUnit?.orgnum !== null && orgUnit?.id > 0" class="sam-margin-left sam-margin-right">·</div>
            <div>{{ orgUnit?.orgnam }}</div>
         </div>
      </div>
   </div>

   <!-- [orgdata]="editableColumn | directoryColumnStructureData | async"
   [orgUnit]="editableColumn | directoryColumnOrganisationUnit" -->

   <kendo-dialog-actions>
      <button kendoButton (click)="cancel()">
         <div class="sam-button-text">{{ 'common.cancel' | translate }}</div>
      </button>
      <button kendoButton (click)="confirm()" primary="true">
         <div class="sam-button-text">
            {{ 'common.ok' | translate }}
         </div>
      </button>
   </kendo-dialog-actions>
</kendo-dialog>
